jQuery(document).ready(function($) {
	$('.contact-form .custom-select').SumoSelect({search: true, searchText: agbsearchText, noMatch: agbnoMatch});
	$('.page-registration .form .custom-select').SumoSelect({search: true, searchText: agbsearchText, noMatch: agbnoMatch});

	$('.career-form .custom-select').SumoSelect({search: true, searchText: agbsearchText, noMatch: agbnoMatch});
	$('.career-form .custom-file-upload input[type=file]').customFile();

	var isotope_container = $('.about-team #team_grid');
	isotope_container.imagesLoaded(function(){
		isotope_container.isotope({
			itemSelector: '.grid-item',
			percentPosition: true,
			masonry: {
				columnWidth: '.grid-sizer'
			}
		})
	});

	if( $('.page-gmap').length>0 ){
		var markers = new Array();

		$.getScript('https://maps.googleapis.com/maps/api/js?key=' + gMapsApiKey, function( data, textStatus, jqxhr ){
			$('.page-gmap').each(function(index){
				var map,
					marker,
					draggableOpt = true,
					$this = $(this),
					lat = $this.data('lat'),
    				lng = $this.data('lng'),
					centerLat = $this.data('center-lat'),
    				centerLng = $this.data('center-lng'),
    				zoom = $this.data('zoom'),
    				infoWindows = [];

    			if( typeof $this.data('center-lat')=='undefined' && typeof $this.data('center-lng')=='undefined' ){
    				centerLat = 0;
    				centerLng = 0;
    			}

    			if( typeof $this.data('zoom')=='undefined' ){
    				zoom = 2;
    			}

				$this.append('<div id="map_' + index + '"></div>');

				map = new google.maps.Map(document.getElementById('map_' + index), {
					zoom: zoom,
					center: {
						lat: centerLat,
						lng: centerLng
					},
					draggable: true,
					scrollwheel: false,
					
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: true,

					zoomControlOptions: {
						style: google.maps.ZoomControlStyle.SMALL,
						position: google.maps.ControlPosition.LEFT_TOP
					},
					streetViewControlOptions: {
						position: google.maps.ControlPosition.LEFT_TOP
					},
					styles: [
					    {
					        "featureType": "water",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "color": "#e9e9e9"
					            },
					            {
					                "lightness": 17
					            }
					        ]
					    },
					    {
					        "featureType": "landscape",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "color": "#f5f5f5"
					            },
					            {
					                "lightness": 20
					            }
					        ]
					    },
					    {
					        "featureType": "road.highway",
					        "elementType": "geometry.fill",
					        "stylers": [
					            {
					                "color": "#ffffff"
					            },
					            {
					                "lightness": 17
					            }
					        ]
					    },
					    {
					        "featureType": "road.highway",
					        "elementType": "geometry.stroke",
					        "stylers": [
					            {
					                "color": "#ffffff"
					            },
					            {
					                "lightness": 29
					            },
					            {
					                "weight": 0.2
					            }
					        ]
					    },
					    {
					        "featureType": "road.arterial",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "color": "#ffffff"
					            },
					            {
					                "lightness": 18
					            }
					        ]
					    },
					    {
					        "featureType": "road.local",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "color": "#ffffff"
					            },
					            {
					                "lightness": 16
					            }
					        ]
					    },
					    {
					        "featureType": "poi",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "color": "#f5f5f5"
					            },
					            {
					                "lightness": 21
					            }
					        ]
					    },
					    {
					        "featureType": "poi.park",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "color": "#dedede"
					            },
					            {
					                "lightness": 21
					            }
					        ]
					    },
					    {
					        "elementType": "labels.text.stroke",
					        "stylers": [
					            {
					                "visibility": "on"
					            },
					            {
					                "color": "#ffffff"
					            },
					            {
					                "lightness": 16
					            }
					        ]
					    },
					    {
					        "elementType": "labels.text.fill",
					        "stylers": [
					            {
					                "saturation": 36
					            },
					            {
					                "color": "#333333"
					            },
					            {
					                "lightness": 40
					            }
					        ]
					    },
					    {
					        "elementType": "labels.icon",
					        "stylers": [
					            {
					                "visibility": "off"
					            }
					        ]
					    },
					    {
					        "featureType": "transit",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "color": "#f2f2f2"
					            },
					            {
					                "lightness": 19
					            }
					        ]
					    },
					    {
					        "featureType": "administrative",
					        "elementType": "geometry.fill",
					        "stylers": [
					            {
					                "color": "#fefefe"
					            },
					            {
					                "lightness": 20
					            }
					        ]
					    },
					    {
					        "featureType": "administrative",
					        "elementType": "geometry.stroke",
					        "stylers": [
					            {
					                "color": "#fefefe"
					            },
					            {
					                "lightness": 17
					            },
					            {
					                "weight": 1.2
					            }
					        ]
					    }
					]
				});
				
				var bounds = new google.maps.LatLngBounds();

				$this.find('.marker').each(function(index){
					var markerPng = $(this).data('png'),
    					markerSvg = $(this).data('svg'),
						markerWidth = $(this).data('width'),
    					markerHeight = $(this).data('height'),
    					group = $(this).data('group'),
						is_internetExplorer11= navigator.userAgent.toLowerCase().indexOf('trident') > -1,
						marker_url = ( is_internetExplorer11 ) ? markerPng : markerSvg;

					var infowindow = new google.maps.InfoWindow({
						content: $(this).html()
					});

					var marker = new google.maps.Marker({
						position: new google.maps.LatLng($(this).data('lat'), $(this).data('lng')),
						map: map,
						icon: {
							url: marker_url,
							size: new google.maps.Size(markerWidth, markerHeight),
							anchor: new google.maps.Point(0, markerHeight)
						},
						zIndex: $(this).data('zindex')
					});

					marker.addListener('click', function() {
						for (var i=0;i<infoWindows.length;i++) {
							infoWindows[i].close();
						}
						infoWindows.push(infowindow);
						infowindow.open(map, marker);
					});

					markers[index] = {
						'group': group,
						'marker': marker
					}

					bounds.extend( marker.position );
				});

				if( markers.length>0 ){
					if( typeof $this.data('center-lat')=='undefined' && typeof $this.data('center-lng')=='undefined' ){
						var extendPoint = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.05, bounds.getNorthEast().lng() + 0.05);
						bounds.extend(extendPoint);
						
						map.fitBounds(bounds);

						if( typeof $this.data('zoom')!='undefined' ){
							var listener = google.maps.event.addListener(map, "idle", function () {
								map.setZoom(zoom);
								google.maps.event.removeListener(listener);
							});
						}
					}
				}
			});
		});

		$('.map-controls > span').click(function(e){
			e.preventDefault();

			for(var i=0; i<markers.length; i++){
				if( markers[i].group==$(this).data('group') ){
					if( $(this).hasClass('active') ){
						markers[i].marker.setVisible(false);
					}
					else{
						markers[i].marker.setVisible(true);
					}
				}
			}

			$(this).toggleClass('active');
		});
	}

	$('.doc-filers .filters label').each(function(){
		if( $(this).find('input').is(':checked') ){
			$(this).addClass('checked');
		}
	});

	$('.doc-filers .filters label input').change(function(){
		$(this).closest('label').toggleClass('checked');
	});

	$('.doc-notification .close-notification').click(function(e){
		e.preventDefault();

		$(this).closest('.doc-notification').slideUp();
	});

	$('.doc-sidebar .has-dropdown.open > ul').show();
	$('.doc-sidebar .has-dropdown > a').map(function(){
		$(this).append('<span class="icon-plus"></span>');
	});
	$('.doc-sidebar .has-dropdown > a > .icon-plus').click(function(e){
		e.preventDefault();

		var $this = $(this);

		if( !$this.closest('.has-dropdown').hasClass('open') ){
			$this.closest('ul').find('.open > ul').slideUp(500, function(){});
			$this.closest('ul').find('.open').removeClass('open');
		}

		if( $this.closest('.has-dropdown').hasClass('open') ){
			$this.closest('.has-dropdown').find('> ul').slideUp(500, function(){
				$this.closest('.has-dropdown').removeClass('open');
			});
		}
		else{
			$this.closest('.has-dropdown').addClass('open');
			$this.closest('.has-dropdown').find('> ul').slideDown(500, function(){});
		}
	});
	
	if( isBreakpoint('lg') ){
		var myTrigger = 'hover';
	}
	else{
		var myTrigger = 'click';
	}
	
	$('.doc-table .table tbody tr td .preview-tooltip').tooltipster({
		arrow: false,
		contentCloning: true,
		side: ['left'],
		trigger: myTrigger,
		theme: 'tooltipster-shadow'
	});

	$('.contact-intro a').on('click', function(e){
		e.preventDefault();

		if( $(this).hasClass('active') ){
			$(this).removeClass('active');
			$( $(this).data('show') ).slideUp();
		}
		else{
			$('.contact-intro a.active').removeClass('active');
			$('.contact-box:visible').slideUp();

			$(this).addClass('active');
			$( $(this).data('show') ).slideDown();
		}
	});

	$('.resellers-select .custom-select').SumoSelect({search: true, searchText: agbsearchText, noMatch: agbnoMatch});
});
